module.exports = new __parcel__URL__("reports-preview-dark.c0a44511.svg").toString();